/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

export interface ActionPayload {
  name: string
  properties: {
    policy: {
      pre: any
    }
    config: {
      unlock_key: string
      trash_key: boolean
    }
  }
  meta: any
  template: string
}

export default class Action {
  payload: ActionPayload

  constructor(payload: ActionPayload) {
    this.payload = payload
  }

  get properties() {
    return this.payload.properties
  }

  get template() {
    return this.payload.template
  }

  get name() {
    return this.payload.name
  }
}
